export default "__VITE_ASSET__BHJFc_Hi__"